var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_644_10692)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5818 7.85307C29.4243 6.53944 28.1864 5.2798 26.8911 5.11104C18.9944 4.12965 11.0067 4.12965 3.10998 5.11104C1.81364 5.27943 0.575677 6.53944 0.418203 7.85307C-0.139401 12.6674 -0.139401 17.3355 0.418203 22.1488C0.575677 23.4624 1.81364 24.7232 3.10998 24.8908C11.0067 25.8722 18.9944 25.8722 26.8911 24.8908C28.1864 24.7235 29.4243 23.4624 29.5818 22.1488C30.1395 17.3359 30.1395 12.6674 29.5818 7.85307ZM12.4998 20.0018V10.0015L20 15.0019L12.4998 20.0018Z",
    fill: "#AE8FD6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_644_10692"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeHome);
export default __webpack_public_path__ + "static/media/Youtube-home.09e11132c6159159d04cd65f04b14460.svg";
export { ForwardRef as ReactComponent };